import React from "react";
import {
  Typography, Grid2 as Grid, TextField, FormControl, Select, MenuItem, FormHelperText,
  InputLabel, FormControlLabel, FormGroup, Checkbox, Link, Button
} from "@mui/material";

import { isEmpty } from "../../components/common/helpers";
import PropTypes from 'prop-types';

const FormHome = ({
  handleChange, handleSubmit,
  errors = {}, newRegister, estados, municipios
}) => {
  return (
    <form onSubmit={handleSubmit} className="needs-validation" noValidate>
      <Grid className="content-form" container sx={{ my: 2 }}>
        <Grid size={12} mt={2}>
          <TextField
            className="input-sigup"
            error={isEmpty(errors.email) ? false : true}
            required
            fullWidth
            id="email"
            label="Email"
            name="email"
            value={newRegister.email}
            placeholder="Tu email"
            onChange={handleChange}
            helperText={!isEmpty(errors.email) && errors.email}
          />
        </Grid>
        <Grid size={{ xs: 5, md: 2 }} mt={2} pr={1}>
          <FormControl sx={{ width: "100%" }}>
            <Select
              autoWidth
              name="ext"
              value={newRegister.ext}
              onChange={handleChange}
            >
              <MenuItem value="52"><img alt="México" width="20" src="/mexico.png" /> +52</MenuItem>
              <MenuItem value="1"><img alt="EEUU" width="20" src="/eeuu.png" /> +1</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid size={{ xs: 7, md: 10 }} mt={2}>
          <TextField
            error={isEmpty(errors.tel) ? false : true}
            variant="outlined"
            required
            fullWidth
            id="tel"
            label="Número celular"
            placeholder="(+00 000-000-000)"
            name="tel"
            value={newRegister.tel}
            onChange={handleChange}
            helperText={!isEmpty(errors.tel) && errors.tel}
          />
        </Grid>
        <Grid size={12} mt={2}>
          <TextField
            className="input-sigup"
            error={isEmpty(errors.razon) ? false : true}
            required
            fullWidth
            id="razon"
            label="Razón social"
            name="razon"
            value={newRegister.razon}
            placeholder="Nombre completo del inversionista o la razón social de la empresa"
            onChange={handleChange}
            helperText={!isEmpty(errors.razon) && errors.razon}
          />
        </Grid>
        <Grid size={12} mt={2}>
          <TextField
            error={isEmpty(errors.rfc) ? false : true}
            required
            fullWidth
            id="rfc"
            label="RFC"
            name="rfc"
            value={newRegister.rfc}
            placeholder="Clave del Registro Federal de Contribuyentes"
            onChange={handleChange}
            helperText={!isEmpty(errors.rfc) && errors.rfc}
          />
        </Grid>
        <Grid size={12} mt={2}>
          <FormControl sx={{ width: "100%" }}>
            <InputLabel>
              Régimen Fiscal
            </InputLabel>
            <Select
              label="Régimen Fiscal"
              name="regimen"
              value={newRegister.regimen}
              onChange={handleChange}
              error={isEmpty(errors.regimen) ? false : true}
            >
              <MenuItem value="">Selecciona</MenuItem>
              <MenuItem value="1">Régimen de Sueldos y Salarios</MenuItem>
              <MenuItem value="2">Régimen de Actividades Empresariales y Profesionales</MenuItem>
              <MenuItem value="3">Régimen de Incorporación Fiscal (RIF)</MenuItem>
              <MenuItem value="4">Régimen de Personas Morales</MenuItem>
              <MenuItem value="5">Régimen de Arrendamiento</MenuItem>
              <MenuItem value="6">Régimen de Intermedios</MenuItem>
              <MenuItem value="7">Régimen de Enajenación de Bienes</MenuItem>
              <MenuItem value="8">Régimen de Consolidación Fiscal</MenuItem>
            </Select>
            <FormHelperText error={isEmpty(errors.regimen) ? false : true}>
              {!isEmpty(errors.regimen) && errors.regimen}
            </FormHelperText>
          </FormControl>
        </Grid>

        <Grid size={12} mt={3}>
          <Typography variant="h3">Dirección fiscal</Typography>
          <Typography>Dirección fiscal registrada ante el SAT</Typography>
        </Grid>

        <Grid size={12} mt={2}>
          <FormControl sx={{ width: "100%" }}>
            <InputLabel>
              País
            </InputLabel>
            <Select
              label="País"
              name="pais"
              value={newRegister?.pais}
              onChange={handleChange}
              error={isEmpty(errors.pais) ? false : true}
            >
              <MenuItem value="">Selecciona</MenuItem>
              <MenuItem value="Mexico">México</MenuItem>
              <MenuItem value="EEUU">EEUU</MenuItem>
            </Select>
            <FormHelperText error={isEmpty(errors.pais) ? false : true}>
              {!isEmpty(errors.pais) && errors.pais}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid size={12} mt={2}>
          <FormControl sx={{ width: "100%" }}>
            <InputLabel>
              Estado
            </InputLabel>
            <Select
              label="Estado"
              name="estado"
              value={newRegister?.estado}
              onChange={handleChange}
              error={isEmpty(errors.estado) ? false : true}
            >
              <MenuItem key="cero" value="">Selecciona</MenuItem>
              {
                newRegister?.pais === "EEUU" ? (
                  estados?.map((info, i) => (
                    <MenuItem key={i} value={info.name}>{info.name}</MenuItem>
                  ))
                ) : newRegister?.pais === "Mexico" ? (
                  estados?.map((info, i) => (
                    <MenuItem key={i} value={info.estado}>{info.estado}</MenuItem>
                  ))
                ) : (
                  <MenuItem value=""></MenuItem>
                )
              }
            </Select>
            <FormHelperText error={isEmpty(errors.estado) ? false : true}>
              {!isEmpty(errors.estado) && errors.estado}
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid size={12} mt={2}>
          {
            newRegister?.pais === "EEUU" ? (
              <TextField
                error={isEmpty(errors.delegacion) ? false : true}
                required
                fullWidth
                id="delegacion"
                label="Delegación o Municipio"
                name="delegacion"
                value={newRegister.delegacion}
                placeholder="Delegación"
                onChange={handleChange}
                helperText={!isEmpty(errors.delegacion) && errors.delegacion}
              />
            ) : (
              <FormControl sx={{ width: "100%" }}>
                <InputLabel>
                  Municipio
                </InputLabel>
                <Select
                  label="Municipio"
                  name="delegacion"
                  value={newRegister.delegacion || ''}
                  onChange={handleChange}
                  error={isEmpty(errors.delegacion) ? false : true}
                >
                  <MenuItem value="">Selecciona</MenuItem>
                  {
                    municipios?.map(info => (
                      <MenuItem selected={info == newRegister.delegacion} key={info} value={info}>{info}</MenuItem>
                    ))
                  }
                </Select>
                <FormHelperText error={isEmpty(errors.delegacion) ? false : true}>
                  {!isEmpty(errors.delegacion) && errors.delegacion}
                </FormHelperText>
              </FormControl>
            )
          }
        </Grid>
        <Grid size={12} mt={2}>
          <TextField
            error={isEmpty(errors.cp) ? false : true}
            required
            fullWidth
            id="cp"
            label="Código Postal"
            name="cp"
            value={newRegister.cp}
            placeholder="Código Postal"
            onChange={handleChange}
            helperText={!isEmpty(errors.cp) && errors.cp}
          />
        </Grid>
        <Grid size={12} mt={2}>
          <TextField
            error={isEmpty(errors.colonia) ? false : true}
            required
            fullWidth
            id="colonia"
            label="Colonia"
            name="colonia"
            value={newRegister.colonia}
            placeholder="Nombre de la colonia"
            onChange={handleChange}
            helperText={!isEmpty(errors.colonia) && errors.colonia}
          />
        </Grid>
        <Grid size={12} mt={2}>
          <TextField
            error={isEmpty(errors.calle) ? false : true}
            required
            fullWidth
            id="calle"
            label="Calle"
            name="calle"
            value={newRegister.calle}
            placeholder="Nombre de la calle"
            onChange={handleChange}
            helperText={!isEmpty(errors.calle) && errors.calle}
          />
        </Grid>
        <Grid size={12} mt={2}>
          <TextField
            error={isEmpty(errors.numExt) ? false : true}
            required
            fullWidth
            id="numExt"
            label="Num exterior"
            name="numExt"
            value={newRegister.numExt}
            placeholder="Num ext"
            onChange={handleChange}
            helperText={!isEmpty(errors.numExt) && errors.numExt}
          />
        </Grid>
        <Grid size={12} mt={2}>
          <TextField
            error={isEmpty(errors.numInt) ? false : true}
            fullWidth
            id="numInt"
            label="Num interior"
            name="numInt"
            value={newRegister.numInt}
            placeholder="Num int"
            onChange={handleChange}
          />
        </Grid>
        <Grid size={12} mt={2}>
          <FormControl
            error={isEmpty(errors.terms) && isEmpty(errors.privacy) ? false : true}
          >
            <FormGroup>
              <FormControlLabel
                control={
                  <Checkbox
                    sx={{ color: "#D8DADC" }}
                    name="terms"
                    color="primary"
                    value={newRegister.terms}
                    onChange={handleChange}
                  />
                }
                label={
                  <>
                    <span>Acepto </span>
                    <Link to={'/'}>términos y condiciones</Link>
                  </>
                }
                required
              />
              <FormControlLabel
                control={
                  <Checkbox
                    sx={{ color: "#D8DADC" }}
                    name="privacy"
                    color="primary"
                    value={newRegister.privacy}
                    onChange={handleChange}
                  />
                }
                label={
                  <>
                    <span>He leído la </span>
                    <Link to={'/'}>política de privacidad</Link>
                  </>
                }
                required
              />
              <FormHelperText>
                {
                  (!isEmpty(errors.terms) || !isEmpty(errors.privacy)) &&
                  errors.terms + ' ' + errors.privacy
                }
              </FormHelperText>
            </FormGroup>
          </FormControl>
        </Grid>
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
        >
          Guardar
        </Button>
      </Grid>
    </form>
  )
}

FormHome.propTypes = {
  newRegister: PropTypes.object.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  municipios: PropTypes.array,
  estados: PropTypes.array.isRequired,
}

export default FormHome